import { authService } from "@/services";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";

/**
 * The signed-in person — as distinct from the organization.
 *
 * Needed because an admin has to be able to see WHICH account they are using
 * before they can sensibly sign out of it. Partner staff routinely hold a
 * personal Curo account and a work one, and signing out of the wrong one is a
 * confusing way to lose your place.
 */
export function useSession() {
	return useQuery({
		queryKey: qk.session,
		queryFn: ({ signal }) => authService.getUser(signal),
		staleTime: 5 * 60_000,
	});
}

/**
 * Supply the display name.
 *
 * Invalidates the session so the roster and the account menu stop showing an
 * address the moment a real name exists.
 */
export function useUpdateName() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (name: string) => authService.updateName(name),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: qk.session });
			qc.invalidateQueries({ queryKey: qk.members() });
		},
	});
}
